import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        isAuth: false,
        empId: "",
        empName: "",
        empType: "",
        empEmail: "",
        token: "",
        roles:[]
    },
    reducers: {
        login(state, action) {
            const s_empType = sessionStorage.getItem('empType')
            state.token = action.payload.token
            state.empId = action.payload.empId
            state.empName = action.payload.empName
            if(state.empType === '' && s_empType){
                state.empType = s_empType
            }
            else{
                state.empType = action.payload.empType
                sessionStorage.setItem('empType', action.payload.empType)
            }
            state.empEmail = action.payload.empEmail
            state.isAuth = true
            state.roles = action.payload.roles
            sessionStorage.setItem('auth', action.payload.token)
        }
        ,
        logout(state){
            sessionStorage.removeItem('auth')
            sessionStorage.removeItem('empType')
        }
    }
});

export const userActions = userSlice.actions